<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Fechamento do Mês</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroFechamentoMes" ref="formCadastroFechamentoMes" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field type="number" v-model.number="item.ano" label="Ano" min="2000" max="2050" maxlength="4" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field type="number" v-model.number="item.mes" label="Mês" min="1" max="12" :rules="fieldRules" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>

<script>
import FechamentoMesService from '../../../core/services/financeiro/FechamentoMesService';
import FechamentoMes from '../../../core/domain/financeiro/FechamentoMes';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroFechamentoMes' in this.$refs)
                this.$refs.formCadastroFechamentoMes.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new FechamentoMesService(),
        valid: true,
        dialog: false,
        isLoading: false,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formCadastroFechamentoMes.validate()) {

                this.salvando = true;

                let modelo = new FechamentoMes(this.item);

                this.service.Salvar(modelo).then(
                    res => {
                        this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    }
}
</script>